import { render, staticRenderFns } from "./ManagerOrder.vue?vue&type=template&id=6364845e"
import script from "./ManagerOrder.vue?vue&type=script&lang=js"
export * from "./ManagerOrder.vue?vue&type=script&lang=js"
import style0 from "./ManagerOrder.vue?vue&type=style&index=0&id=6364845e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports